module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgB7ZTvEYIwDMWfHAPgBriBG4gTwAbWUZxANwA3wQ3cADbQDTSRgBWb4lk/+rt7d/2XlzbtFXDTkAroJKQLaTmeiJSAVIJ8hom2ZiPZboF6nGomjZZ0tJKUpIp0gr7DPWknsUxOyiDuZhTwaQ0za8ywV6wELODnSpq7JnpDruMKYaS2YYpwhht31fAbDHtF+DGRJ1tm9Qu83noGz6lcR+ax0uo3op5K1ow3oT6bNZ4Pltmieyo9BzF9QzOsJ/pnKPxrOFBP9NUaxpI5Rzjs0XLDoKtP6AfL35m5A6lVWkBsdfGfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/form-ui/calendar.png
// module id = uzkt
// module chunks = 46